<template>
  <div class="koperasiAbadi">
    <menuBox :step="1"></menuBox>
    <div class="koperasiAbadi-content">
      <div class="koperasiAbadi-box">
        <p class="bt">Bergabunglah dengan tim elit kami</p>
        <span class="title">Temukan talenta yang bersemangat di bidang keuangan untuk menciptakan masa depan bersama dan
          mewujudkan potensi Anda.</span>
        <div class="btn" @click="step">
          Belajarlah lagi
        </div>
      </div>
    </div>
    <div class="industries-box">
      <div class="title">Highlight</div>
      <div class="lineBox"></div>
      <div class="text">Gunakan upaya kami untuk mendorong pembangunan sosial</div>
      <div class="itemBox">
        <div class="item">
          <img class="industries" src="../assets/industries1.png" alt="">
          <div class="titleBox">
            <p>rencana keuangan</p>
            <span>Menyediakan layanan perencanaan keuangan yang dipersonalisasi untuk membantu Anda mengembangkan
              kekayaan
              Anda.</span>
          </div>
        </div>
        <div class="item">
          <img class="industries" src="../assets/industries2.png" alt="">
          <div class="titleBox">
            <p>perantara uang</p>
            <span>Menjembatani lembaga keuangan dan nasabah untuk mengoptimalkan aliran modal.</span>
          </div>
        </div>
        <div class="item">
          <img class="industries" src="../assets/industries3.png" alt="">
          <div class="titleBox">
            <p>layanan asuransi</p>
            <span>Solusi asuransi komprehensif untuk menjamin keamanan finansial Anda.</span>
          </div>
        </div>
      </div>
    </div>
    <div class="impact-box">
      <img src="../assets/impact.png" alt="">
      <div class="impact-content">
        <div class="bt">Tren Pertumbuhan Ekonomi Keuangan</div>
        <div class="lineBox"></div>
        <div class="text">Tren pertumbuhan ekonomi keuangan terutama tercermin dalam promosi globalisasi dan inovasi
          teknologi. Layanan keuangan cenderung bersifat digital dan cerdas, sehingga memberikan dorongan yang kuat bagi
          pertumbuhan ekonomi global. Pada saat yang sama, integrasi dan diversifikasi pasar keuangan semakin mendalam,
          dan vitalitas pasar negara berkembang terus meningkat, mendorong aliran modal dan efisiensi investasi, serta
          berkontribusi terhadap stabilitas dan perkembangan perekonomian dunia.
        </div>
      </div>
    </div>
    <div class="reasone-box">
      <div class="itemBox">
        <div class="item">
          <p>Globalisasi</p>
          <span>Ada aliran modal yang bebas dan hubungan pasar yang kuat.</span>
        </div>
        <div class="item">
          <p>Digitalisasi</p>
          <span>Inovasi teknologi keuangan dan pemasyarakatan layanan yang cepat.</span>
        </div>
        <div class="item">
          <p>Diversifikasi</p>
          <span>Ada saluran investasi yang kaya dan pilihan yang beragam.</span>
        </div>
        <div class="item">
          <p>Tidak pasti</p>
          <span>Volatilitas pasar sering terjadi dan manajemen risiko adalah kuncinya.</span>
        </div>
      </div>
    </div>
    <div class="latest-box">
      <div class="title">Pengembangan masa depan</div>
      <div class="lineBox"></div>
      <div class="itemBox">
        <div class="item">
          <img src="../assets/latest1.png" alt="">
          <p>Inovasi</p>
          <span>Memperkenalkan teknologi keuangan terkini untuk meningkatkan efisiensi layanan.</span>
        </div>
        <div class="item">
          <img src="../assets/latest2.png" alt="">
          <p>Ekspansi</p>
          <span>Cakupan bisnis dan cakupan pasar terus meningkat.</span>
        </div>
        <div class="item">
          <img src="../assets/latest3.png" alt="">
          <p>Bekerja sama</p>
          <span>Menjalin hubungan kerja sama dengan banyak lembaga keuangan terkemuka.</span>
        </div>
      </div>
    </div>
    <div class="tounch-box">
      <div class="left">
        <div class="title">Hubungi kami</div>
        <div class="lineBox"></div>
        <div class="text">Untuk konsultasi dan saran kerjasama keuangan, Anda dapat menghubungi kami melalui saluran
          berikut</div>
        <div class="list">
          <p>Alamat:</p>
          <span>The Manhattan Square Jalan TB Simatupang, RT.3/RW.3, Cilandak Timur, Pasar Minggu, Jakarta Selatan</span>
        </div>
        <!-- <div class="list">
          <p>Telepon:</p>
          <span>85213110210</span>
        </div> -->
        <div class="list">
          <p>Surat:</p>
          <span>EPearson19790103@gmail.com</span>
        </div>
      </div>
      <div class="right">
        <div class="item">
          <div class="lable">Nama</div>
          <input type="text">
        </div>
        <div class="item">
          <div class="lable">
            Surel</div>
          <input type="text">
        </div>
        <div class="item">
          <div class="lable">Pesan</div>
          <textarea type="text" />
        </div>
        <div class="btn" @click="subMit">
          mengonfirmasi</div>
      </div>
    </div>
    <footerBox :step="1"></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "home",
  components: {
    menuBox,
    footerBox
  },
  data() {
    return {
      type: 1,
    };
  },
  mounted() { },
  methods: {
    step() {
      this.$router.push({ path: "About" });
    },
    subMit() {
      alert("kesuksesan!")
    }
  },
};
</script>

<style lang="less" scoped>
.koperasiAbadi-content {
  position: relative;

  .koperasiAbadi-box {
    background-image: url(../assets/home.png);
    width: 100%;
    height: 600px;
    background-size: 100% 100%;
    padding: 100px 360px 0 360px;
    overflow: hidden;
    box-sizing: border-box;

    .bt {
      max-width: 600px;
      margin-bottom: 30px;
      font-family: Roboto, Roboto;
      font-weight: bold;
      font-size: 64px;
      line-height: 67px;
      color: #FFFFFF;
    }

    .title {
      display: block;
      max-width: 600px;
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 20px;
      color: #FFFFFF;
      line-height: 25px;
    }

    .btn {
      margin-top: 42px;
      cursor: pointer;
      width: 220px;
      padding: 16px 0;
      background: #CF9555;
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 28px;
      text-align: center;
      color: #FFFFFF;
    }
  }
}

.industries-box {
  padding: 120px 360px;

  .title {
    margin-bottom: 30px;
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 46px;
    color: #333333;
    text-align: center;
  }

  .lineBox {
    width: 80px;
    height: 8px;
    background: #CF9555;
    border-radius: 80px 80px 80px 80px;
    margin: 0 auto 20px;
  }

  .text {
    margin: 20px 0 60px;
    text-align: center;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 19px;
    color: #999999;
    line-height: 29px;
  }

  .itemBox {
    display: flex;
    justify-content: space-between;

    .item {
      width: 28%;
      text-align: center;

      .industries {
        margin-bottom: 35px;
        width: 83px;
        height: 83px;
      }

      .titleBox {
        p {
          margin-bottom: 16px;
          font-family: Roboto, Roboto;
          font-weight: 500;
          font-size: 30px;
          color: #333333;
          line-height: 35px;
        }

        span {
          font-family: Roboto, Roboto;
          font-size: 20px;
          color: #999999;
          line-height: 28px;
        }
      }
    }

    .item:nth-child(3) {
      margin-right: 0;
    }
  }
}

.impact-box {
  display: flex;

  img {
    margin-right: 60px;
    width: 956px;
    height: 537px;
  }

  .impact-content {
    padding-top: 66px;

    .bt {
      margin-bottom: 33px;
      font-family: Roboto, Roboto;
      font-weight: 500;
      font-size: 40px;
      color: #333333;
      line-height: 48px;
    }

    .lineBox {
      margin-bottom: 40px;
      width: 59px;
      height: 8px;
      background: #CF9555;
    }

    .title {
      max-width: 626px;
      margin-bottom: 15px;
      font-family: Roboto, Roboto;
      font-weight: 500;
      font-size: 22px;
      color: #333333;
      line-height: 33px;
    }

    .text {
      max-width: 626px;
      font-family: Roboto, Roboto;
      font-size: 18px;
      color: #999999;
      line-height: 27px;
    }
  }
}

.reasone-box {
  padding: 0px 360px;
  background: #353C4E;

  .itemBox {
    display: flex;

    .item {
      width: 25%;
      padding: 30px 60px;
      border-right: 1px solid rgba(224, 224, 224, 0.12);

      p {
        margin-bottom: 10px;
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 24px;
        color: #FFFFFF;
        line-height: 36px;
      }

      span {
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 24px
      }
    }

    .item:nth-child(4) {
      border: none;
    }
  }
}

.latest-box {
  padding: 150px 360px;
  text-align: center;

  .title {
    margin-bottom: 33px;
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 46px;
    color: #333333;
    line-height: 55px;
  }

  .lineBox {
    margin: 0 auto 33px;
    width: 80px;
    height: 8px;
    background: #CF9555
  }

  .itemBox {
    display: flex;

    .item {
      position: relative;
      margin-right: 25px;

      img {
        width: 383px;
        height: 260px;
      }

      p {
        position: absolute;
        top: 227px;
        left: 50%;
        transform: translate(-50%, 0%);
        width: 257px;
        height: 60px;
        line-height: 60px;
        background: #353C4E;
        font-family: Roboto, Roboto;
        font-weight: 500;
        font-size: 24px;
        color: #FFFFFF;
      }

      span {
        display: block;
        margin-top: 40px;
        font-family: Roboto, Roboto;
        font-weight: 500;
        font-size: 20px;
        color: #333333;
        line-height: 30px;
      }
    }

    .item:nth-child(3) {
      margin-right: 0;
    }

    .item:nth-child(2) {
      p {
        background: #CF9555;
      }
    }

  }
}

.tounch-box {
  display: flex;
  justify-content: space-between;
  padding: 0 360px 120px;

  .left {
    max-width: 500px;

    .title {
      margin-bottom: 30px;
      font-family: Roboto, Roboto;
      font-weight: 500;
      font-size: 46px;
      color: #333333;
      line-height: 55px;
    }

    .lineBox {
      margin-bottom: 30px;
      width: 59px;
      height: 8px;
      background: #CF9555;
    }

    .text {
      margin-bottom: 40px;
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 18px;
      color: #999999;
      line-height: 27px;
    }

    .list {
      margin-bottom: 60px;

      p {
        margin-bottom: 10px;
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 24px;
        color: #333333;
        line-height: 28px;
      }

      span {
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 18px;
        color: #999999;
        line-height: 28px;
      }
    }
  }

  .right {
    .item {
      margin-bottom: 30px;

      .lable {
        margin-bottom: 20px;
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 24px;
        color: #333333;
        line-height: 36px;
      }

      input {
        width: 554px;
        height: 48px;
        background: #F6F6F6;
        padding: 0 20px;
        border: none;
      }

      textarea {

        width: 554px;
        height: 180px;
        padding: 20px;
        background: #F6F6F6;
        border: none;
      }

      input:focus-visible {
        outline: none;
      }

      textarea:focus-visible {
        outline: none;
      }
    }

    .btn {
      float: right;
      padding: 12px 24px;
      font-size: 20px;
      color: #FFFFFF;
      background: #CF9555;
      cursor: pointer;
    }
  }
}
</style>
